import script from "./repeat-pickure.vue?vue&type=script&lang=tsx&setup=true"
export * from "./repeat-pickure.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__